<template>
  <a-button style="width: 120px" @click="showUpdatePasswordModal">
    <template #icon>
        <LockOutlined />
    </template>
    變更密碼
  </a-button>
  <a-modal v-model:open="isOpen" width="600px" title="變更密碼" 
      :centered="isModalCentered" :maskClosable="isMaskClosable" 
      :closable="isMaskClosable" :cancelButtonProps="cancelButtonProps" 
      :confirm-loading="isUpdatingPassword" okText="確認" cancelText="取消" 
      @cancel="cancelUpdatingPassword" @ok="saveUpdatingPassword">
    <a-divider />
    <a-form ref="updatePasswordForm" :model="formState" name="basic" 
        :rules="formRules" :label-col="{ span: 7 }" 
        :wrapper-col="{ span: 12 }" :disabled="isUpdatingPassword">
        <!-- 舊密碼 -->
        <a-form-item ref="originalPassword" label="舊密碼" name="originalPassword">
          <a-input-password v-model:value="formState.originalPassword">
            <template #prefix>
              <LockOutlined class="site-form-item-icon" />
            </template>
          </a-input-password>
        </a-form-item>
        <!-- 新密碼 -->
        <a-form-item ref="newPassword" label="新密碼" name="newPassword">
          <a-input-password v-model:value="formState.newPassword">
            <template #prefix>
              <LockOutlined class="site-form-item-icon" />
            </template>
          </a-input-password>
        </a-form-item>
        <!-- 確認新密碼 -->
        <a-form-item ref="newPasswordConfirm" label="確認新密碼" name="newPasswordConfirm">
          <a-input-password v-model:value="formState.newPasswordConfirm">
            <template #prefix>
              <LockOutlined class="site-form-item-icon" />
            </template>
          </a-input-password>
        </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup>
import { LockOutlined } from "@ant-design/icons-vue";
import { ref, reactive, defineEmits } from 'vue';

import common from "@/common";
import config from "@/config";

const emit = defineEmits(['cancel', 'submit-success']);

const updatePasswordForm = ref();
const isOpen = ref(false);
const isModalCentered = ref(true);
const isMaskClosable = ref(false);
const isUpdatingPassword = ref(false);
const cancelButtonProps = ref({
  disabled: isUpdatingPassword
});
const formState = reactive({
    originalPassword: '',
    newPassword: '',
    newPasswordConfirm: ''
});
const formRules = {
  originalPassword: [{
    required: true,
    message: '請輸入目前所使用的密碼',
    trigger: ['change', 'blur']
  }],
  newPassword: [{
    required: true,
    message: '請輸入新密碼',
    trigger: ['change', 'blur']
  }],
  newPasswordConfirm: [{
    required: true,
    message: '請再輸入一次新密碼',
    trigger: ['change', 'blur']
  }, {
    message: '與新密碼不符',
    trigger: ['blur'],
    validator: (rule, value) => {
      if (value == null || 
          value.length < 1 || 
          formState.newPassword === formState.newPasswordConfirm) {
        return Promise.resolve();
      }
      return Promise.reject(rule.message);
    }
  }]
};

const resetModalState = () => {
  if (updatePasswordForm.value != null) {
    updatePasswordForm.value.resetFields();
  }
  formState.originalPassword = '';
  formState.newPassword = '';
  formState.newPasswordConfirm = '';
}

const showUpdatePasswordModal = () => {
  isOpen.value = true;
  resetModalState();
};

const cancelUpdatingPassword = () => {
  isOpen.value = false;
  emit('cancel');
}

const saveUpdatingPassword = () => {
  updatePasswordForm.value.validate()
  .then(() => {
    isUpdatingPassword.value = true;
    common.postRequest(config.mgmtUpdateUserCredential, formState, 
      (response) => {
        isUpdatingPassword.value = false;
        isOpen.value = false;
        emit('submit-success', response.data);
      }, () => {
        isUpdatingPassword.value = false;
      });
  }).catch(() => { });
}

</script>
<style scoped>
  button,
  span {
    display: inline-flex;
    align-items: center;
  }
  .input-text-style {
    width: 200px;
  }
</style>